import { LazyPage, PipelineDestinationsJourneysPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineDestinationsJourneysRoute() {
  return (
    <LazyPage>
      <PipelineDestinationsJourneysPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys')({
  component: PipelineDestinationsJourneysRoute,
});
